export const PrivateRoutes = [
  { url: "/home", label: "Home", context: "home" },
  // { url: "/benefit", label: "Segmentações", context: "cbenefit" },
  { url: "/solicitation", label: "Pedidos", context: "solicitations" },
  // { url: "/refund", label: "Reembolsos", context: "refund" },
  { url: "/company", label: "Empresas", context: "companies" },
  { url: "/user", label: "Participantes", context: "employees" },
  { url: "/card", label: "Cartão", context: "card" },
  { url: "/transfer", label: "Tesouraria", context: "transfers" },
  { url: "/internal-transfer", label: "Transferência", context: "internal-transfers" },
  { url: "/extract", label: "Extrato Geral", context: "extract" },
  { url: "/reward-voucher", label: "Link+", context: "reward-voucher" },
  { url: "/breakage", label: "Breakage", context: "breakage" },
  // { url: "/expense", label: "Gastos", context: "expense" },
];
